export enum PaymentStatus {
  Created = "CREATED",
  Completed = "COMPLETED",
}
